/**
 * @generated SignedSource<<4ae5a3e473f07ae9b2f54942ca933bb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageBannerContent_messages$data = ReadonlyArray<{
  readonly items: ReadonlyArray<{
    readonly note: {
      readonly anchors: ReadonlyArray<{
        readonly content: {
          readonly cta: {
            readonly text: string | null;
            readonly url: string | null;
          } | null;
          readonly message: string | null;
          readonly title: string | null;
        } | null;
        readonly serviceId: string | null;
      } | null> | null;
      readonly content: {
        readonly cta: {
          readonly text: string | null;
          readonly url: string | null;
        } | null;
        readonly message: string | null;
        readonly title: string | null;
      } | null;
      readonly serviceId: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "MessageBannerContent_messages";
}>;
export type MessageBannerContent_messages$key = ReadonlyArray<{
  readonly " $data"?: MessageBannerContent_messages$data;
  readonly " $fragmentSpreads": FragmentRefs<"MessageBannerContent_messages">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketingMessageContent",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MarketingMessageCta",
      "kind": "LinkedField",
      "name": "cta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "MessageBannerContent_messages",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MessageSetItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MarketingMessage",
          "kind": "LinkedField",
          "name": "note",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "MarketingMessage",
              "kind": "LinkedField",
              "name": "anchors",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MessageSetModule",
  "abstractKey": null
};
})();

(node as any).hash = "ef74e623e41de3713221c6201504c064";

export default node;
